import React from 'react';
import type { RowAxis } from 'src/components/star-grid/api/reportEngineTypes';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import styles from 'src/components/star-grid/components/styles/ReportStudio.module.scss';

interface Props {
  readonly axis?: RowAxis;
  readonly text: StarGridText;
  /** The line set lists every member; the shelf shows only the dimension and a count. */
  readonly listMembers?: boolean;
}

/** A two-dimension report's second row column: the dimension each row is also split by. */
export const StudioNestedRows: React.FC<Props> = ({ axis, text, listMembers }) => {
  if (!axis) return null;
  const members = axis.selector.elements ?? [];
  return (
    <div className={styles.nestedRows} data-testid="studio-nested-rows">
      <span className={styles.nestedRowsLabel}>{text('studioSecondRowColumn')}</span>
      <strong>{axis.dimension}</strong>
      <span className={styles.nestedRowsCount}>{`${members.length} ${text('studioMembers')}`}</span>
      {listMembers && members.length > 0 && (
        <ul className={styles.nestedRowsList}>
          {members.map((member) => (
            <li key={member}>{member}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
